<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <div>
              <b-row>
                <b-col sm="3">
                  <i class="fa fa-bars"></i> {{$t('str.banner-interaction')}}
                </b-col>
                <b-col sm="9"></b-col>
              </b-row>
            </div>

            <div>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="4">{{$t('str.country')}}</b-col>
                    <b-col sm="4"></b-col>
                    <b-col sm="4"></b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="4">
                      <b-form-select id="country_id" name="country_id" :plain="true" v-model="country_id"
                        style="height:100%;">
                        <option value="">{{$t('str.all')}}</option>
                        <option v-for="(c, index) in countrySelect" :value="c.value" :key="index">{{c.text}}</option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="4"></b-col>
                    <b-col sm="4">
                      <buttons button-type="search" @click="getList()" />&nbsp;
                      <buttons button-type="reset_filter" @click="resetFilter()" />
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>

          <p :class="{'text-center':true, 'd-none':items.length}" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{'d-none':!items.length}" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="created_at" slot-scope="data">
              {{ data.item.created_at | moment('from', 'now') }}
            </template>
          </b-table>
          <nav :class="{'d-none':!items.length}">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'

import Pagination from '@/views/component/Pagination'
import ConfirmModal from '@/views/component/ConfirmModal'
import Buttons from '@/views/component/Buttons'
import ImgModal from '@/views/component/ImgModal'

export default {
  name: 'BannerInteraction',
  components: {
    'paging': Pagination,
    'confirm-modal': ConfirmModal,
    'buttons': Buttons,
    'img-modal': ImgModal
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      id: this.$route.params.id,
      items: [],
      fields: [
        { key: 'user_name', label: 'Clicked by', sortable: true },
        { key: 'user_country', label: 'Clicked from', sortable: true },
        { key: 'user_platform', label: 'Clicked using', sortable: true },
        { key: 'created_at', label: 'Clicked at', sortable: true }
      ],
      currentPage: 1,
      totalPage: 0,
      country_id: '',
      countrySelect: []
    }
  },
  methods: {
    async getCountrySelect() {
      this.$auth.checkSession()
      let bannerId = this.id
      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/BannerInteraction/Banner/${bannerId}/Country`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        let cData = getData.data.data

        for (let i = 0; i < cData.length; i++) {
          this.countrySelect.push({ 'value': cData[i].id, 'text': cData[i].name })
        }
      } catch (e) {
        console.log(e)
      }
    },
    async getList(page) {
      this.$auth.checkSession()
      let bannerId = this.id

      let trail = `?limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail += `&page=${page}`
      if (this.country_id != '') trail += `&country_id=${this.country_id}`

      try {
        let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/BannerInteraction/Banner/${bannerId}${trail}`, {
          headers: { 'Authorization': `Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data

        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch (e) {
        console.log(e)
      }
    },
    resetFilter() {
      this.keyword = ''
      this.country_code = ''
      this.getCountrySelect()
      this.getList()
    },
    pageOneChanged(pageNum) {
      this.$auth.checkSession()
      this.currentPage = pageNum
      this.getList(pageNum)
    }
  },
  created() {
    this.getCountrySelect()
    this.getList()
  }
}
</script>